<template>
  <div class="appset">
    <div class="appset-cont pad_20 ba_f">
      <div class="shuju_title mar_b20">
        <div class="shuju_title_text">
          <span>{{ $t('plugin.appSet.title') }}</span>
        </div>
      </div>
      <h3 class="title-box">
        <span class="wei fon_18 pad_l_20">{{ $t('plugin.appSet.subtitle') }}</span>
        <span class="color_b mar_l10 curs">{{ $t('plugin.appSet.viewTutorial') }}</span>
      </h3>
      <div class="pad_20 flex-y-top">
        <el-steps class="flex-grow-1" style="min-height: 450px;" :active="active" :align-center="true" direction="vertical" :space="150">
          <el-step :title="$t('plugin.appSet.step1Title')">
            <template slot="description">
              <span>{{ $t('plugin.appSet.step1Desc1') }}</span>
              <a class="color_b" :href="appSetInfo.url || 'https://www.pgyer.com/jhDH'" target="_blank">{{ appSetInfo.url || 'https://www.pgyer.com/jhDH' }}</a>
              <span>{{ $t('plugin.appSet.step1Desc2') }}</span>
              <img class="ewm mar_l10" v-if="appSetInfo.qrCode" :src="appSetInfo.qrCode" alt />
              <img class="ewm mar_l10" v-else src="~@/assets/img/ewm.png" alt />
            </template>
          </el-step>
          <el-step :title="$t('plugin.appSet.step2Title')">
            <template slot="description">
              <span>{{ $t('plugin.appSet.step2Desc1') }}</span>
              <span class="color_b">{{ appSetInfo.domain }}</span>
              <span>{{ $t('plugin.appSet.step2Desc2') }}</span>
              <span class="color_b">{{ appSetInfo.systemId }}</span>
              <span>{{ $t('plugin.appSet.step2Desc3') }}</span>
            </template>
          </el-step>
          <el-step :title="$t('plugin.appSet.step3Title')" :description="$t('plugin.appSet.step3Desc')"></el-step>
        </el-steps>
        <div class="flex-colbt" style="height: 350px;">
          <div class="flex-grow-1">
            <a :href="appSetInfo.url || 'https://www.pgyer.com/jhDH'" rel="noopener noreferrer">
              <el-button type="primary">{{ $t('plugin.appSet.downloadNow') }}</el-button>
            </a>
          </div>
          <div class="flex-grow-1">
            <el-button type="primary">{{ $t('plugin.appSet.preview') }}</el-button>
          </div>
          <router-link to="/applicationlist">
            <div class="flex-grow-1">
              <el-button type="primary">{{ $t('plugin.appSet.configureNow') }}</el-button>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAppSetInfo } from '@/api/plugins.js';
export default {
  data() {
    return {
      loadingShow: true,
      active: 3,
      appSetInfo: {}
    };
  },
  created() {
    this.getAppSetInfo();
  },
  methods: {
    getAppSetInfo() {
      getAppSetInfo().then((res) => {
        if (res.code == 1) {
          this.appSetInfo = res.data;
        }
      });
    }
  }
};
</script>

<style lang="stylus" scoped>
>>>.el-step__title {
  font-weight: 400;
  font-size: 14px;
}

>>>.el-step__description {
  font-size: 12px;
  color: #999;
}

>>>.el-step__icon {
  background: #2A75ED;
  color: #ffffff;
}

>>>.is-process {
  .el-step__icon {
    background: #000;
    color: #ffffff;
  }
}

>>>.el-step__title {
  color: #333;
}

>>>.is-wait {
  .el-step__icon {
    background: #C0C4CC;
    color: #ffffff;
  }
}

.ewm {
  width: 100px;
  height: 100px;
  vertical-align: top;
}
</style>
